import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import QueryString from 'query-string';

import { authWithToken } from '../../actions/auth';

class AuthRequired extends React.Component {
  componentWillMount() {
    if (this.props.isLoggedIn) {
      return;
    }
    const { currentURL } = this.props;
    const params = QueryString.parse(this.props.params);
    if (params.token && !this.props.isAuthenticating) {
      // request to auth with token
      this.props.authWithToken(params.token, currentURL);
      return;
    }
    browserHistory.push(`/login?next=${currentURL}`);
  }
  render() {
    if (this.props.isLoggedIn) {
      return this.props.children;
    }
    if (this.props.isAuthenticating) {
      return <p>Loading</p>;
    }
    return null;
  }
}

AuthRequired.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  isAuthenticating: PropTypes.bool.isRequired,
  currentURL: PropTypes.string.isRequired,
  params: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  authWithToken: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  authWithToken,
};
const mapStateToProps = (state, ownProps) => ({
  isLoggedIn: state.auth.isAuthenticated,
  isAuthenticating: state.auth.isAuthenticating,
  currentURL: ownProps.location.pathname,
  params: ownProps.location.search,
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthRequired);



// WEBPACK FOOTER //
// src/components/AuthRequired/AuthRequired.js